import { Banknote, Building2, CreditCard, Coins, Smartphone } from 'lucide-react';

export const PAYMENT_METHODS = [
  { value: 'cash', label: 'Cash', icon: Banknote },
  { value: 'cash_app', label: 'Cash App', icon: Smartphone },
  { value: 'venmo', label: 'Venmo', icon: Smartphone },
  { value: 'paypal', label: 'PayPal', icon: Smartphone },
  { value: 'zelle', label: 'Zelle', icon: Building2 },
  { value: 'card', label: 'Card', icon: CreditCard },
  { value: 'apple_pay', label: 'Apple Pay', icon: Smartphone },
  { value: 'crypto', label: 'Crypto', icon: Coins },
  { value: 'bank_transfer', label: 'Bank Transfer', icon: Building2 },
  { value: 'other', label: 'Other', icon: CreditCard },
] as const;
